import { Button, Grid } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress';
import { useEffect, useState } from 'react';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';

export default function UploadAndExportButton(props: any) {
    const { machineScan, machineActive, disableUploadExportButton } = props
    const [uploadExportButtonClicked, setUploadExportButtonClicked] = useState<boolean>(false);
    const [dots, setDots] = useState<string>("");
    const { t } = useTranslation();

    const styles = {
        CircularProgress: {
            mr: 1,
            color: "#FFFFFF"
        },
        dotsContainer: {
            display: 'inline-block',
            width: '24px',  // Fixed width for the dots
            textAlign: 'left'
        }
    }

    useEffect(() => {
        if (uploadExportButtonClicked && !machineActive) {
            setUploadExportButtonClicked(false)
        }
    }, [uploadExportButtonClicked, machineActive, setUploadExportButtonClicked])

    // Animate the dots when the button is clicked and the machine is active
    useEffect(() => {
        let dotsInterval: NodeJS.Timeout;

        if (uploadExportButtonClicked && machineActive) {
            dotsInterval = setInterval(() => {
                setDots(prevDots => {
                    if (prevDots.length >= 3) return "";
                    return prevDots + ".";
                });
            }, 500); // Change dot every 500ms
        }

        return () => {
            if (dotsInterval) clearInterval(dotsInterval);
        };
    }, [uploadExportButtonClicked, machineActive]);    

    if (!machineActive) {
        return (
            <Grid item md={11} xs={11} pt={2}>
                <Button className="Upload-Export-Blue" disabled={disableUploadExportButton} fullWidth onClick={() => {
                    machineScan("uploadAndExport")
                    setUploadExportButtonClicked(true)
                }}>{t('control.inputs.buttons.uploadExport')}</Button>
            </Grid>
        )
    } else {
        return (
            <Grid item md={11} xs={11} pt={2}>
                <Button className="Upload-Export-Blue" disabled fullWidth onClick={() => { machineScan("uploadAndExport") }}>
                    {uploadExportButtonClicked ?
                        <>
                            {`${t('control.inputs.buttons.uploading')} ${t('control.inputs.buttons.export').toLowerCase()}`}<Box component="span" sx={styles.dotsContainer}>{dots}</Box>
                        </>
                        :
                        <CircularProgress size={25} sx={styles.CircularProgress} />
                    }
                </Button>
            </Grid>
        )
    }
}